import styled, { css } from 'styled-components';
import { renderTextVariations } from '../utils/renderTextVariations.js';
import { wrapContentWithSeparator } from '../utils/wrapContentWithSeparator.js';

const Title = styled.h1(({ type = 'default', bold, separator, stylish, theme: { olist: { components: { text: { title }, }, }, }, }) => css `
      ${renderTextVariations(title, type, bold, stylish)}
      ${separator && wrapContentWithSeparator()}
    `);

export { Title as default };
